import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { api, API } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { FileDown, BookOpenCheck } from "lucide-react";
import { MonthPicker, currentMonth, monthLabel } from "@/components/MonthPicker";
import { secureClick } from "@/lib/openFile";
import { TIPI_INTERVENTO } from "@/lib/constants";

export const RegistroMensile = () => {
  const [mese, setMese] = useState(currentMonth());
  const [dist, setDist] = useState("tutti");
  const [tipo, setTipo] = useState("tutti");
  const { data: distaccamenti = [] } = useQuery({ queryKey: ["distaccamenti"], queryFn: async () => (await api.get("/guardie/distaccamenti")).data });
  const url = `${API}/interventi-registro/pdf?${new URLSearchParams({ mese, distaccamento: dist, tipo })}`;
  return (
    <Card className="mb-6 border-slate-200 shadow-sm" data-testid="registro-mensile-card">
      <CardContent className="flex flex-wrap items-center gap-3 p-4">
        <div className="flex items-center gap-2 pr-2">
          <BookOpenCheck className="h-5 w-5 text-[#166534]" />
          <p className="font-heading text-sm font-bold text-slate-900">Registro mensile verificati</p>
        </div>
        <MonthPicker value={mese} onChange={setMese} testid="registro-month" />
        <Select value={dist} onValueChange={setDist}>
          <SelectTrigger className="w-[270px]" data-testid="registro-distaccamento"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="tutti">Distaccamento (registro): tutti</SelectItem>
            {distaccamenti.map((d) => <SelectItem key={d} value={d}>{d}</SelectItem>)}
          </SelectContent>
        </Select>
        <Select value={tipo} onValueChange={setTipo}>
          <SelectTrigger className="w-[200px]" data-testid="registro-tipo"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="tutti">Tipo (registro): tutti</SelectItem>
            {TIPI_INTERVENTO.map((t) => <SelectItem key={t} value={t}>{t}</SelectItem>)}
          </SelectContent>
        </Select>
        <Button asChild className="bg-[#14382C] hover:bg-[#0E281F]">
          <a href={url} onClick={secureClick(url)} target="_blank" rel="noopener noreferrer" data-testid="registro-pdf">
            <FileDown className="mr-2 h-4 w-4" /> PDF {monthLabel(mese)}
          </a>
        </Button>
      </CardContent>
    </Card>
  );
};
